import { render, staticRenderFns } from "./CreateBudgetApplication.vue?vue&type=template&id=8b5ce8ae&"
import script from "./CreateBudgetApplication.vue?vue&type=script&lang=js&"
export * from "./CreateBudgetApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports